import React, { Component } from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'
import SectionsEditForm from './sections.component.jsx'
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
const uuidv4 = require('uuid/v4')

class ModelEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.model = this.props.model
        let modelId = uuidv4()
        if (this.model) {
            modelId = this.model.id
        }
        this.state = {
            id: modelId,
            name: '',
            deleteButton: '',
            sections: [],
            sectionsForm: '',
        }

        this.submitModel = this.submitModel.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteModel = this.deleteModel.bind(this)
        this.handleSectionsChange = this.handleSectionsChange.bind(this)

        if (this.model && this.model.id) {
            this.originalModel = JSON.parse(JSON.stringify(this.props.model))
            this.state.name = this.model.attributes.name
            this.state.sections = this.model.attributes.sections
            this.state.deleteButton = <ConfirmButton identifier={this.state.name} href="#" onClick={this.deleteModel} className="btn btn-danger">
                <FormattedMessage
                    id="guided_selling.form.edit.delete_btn"
                    defaultMessage="Delete model"
                />
            </ConfirmButton>
        }
    }

    componentDidMount() {}

    deleteModel(event) {
        event.preventDefault()
        AppContext.getApiClient().delete('/guided-selling-models/' + this.state.id).then((response) => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/models/listing' }} /> })
            }
        })
    }

    flatSections(sections) {
        const sectionsFlat = []
        for (let i in sections) {
            sectionsFlat.push(sections[i])
            for (let j in sections[i].attributes.subSections) {
                sectionsFlat.push(sections[i].attributes.subSections[j])
            }
        }
        return sectionsFlat
    }

    saveModel() {
        const model = this.originalModel
        const newSections = this.flatSections(this.state.sections)

        const apiCalls = newSections.map(
            section => AppContext.getApiClient().put('/guided-selling-sections/' + section.id, {
                "order": section.attributes.order,
                "name": section.attributes.name,
                "description": section.attributes.description,
                "labelIds": section.attributes.labelIds,
                "modelId": section.attributes.modelId,
                "parentSectionId": section.attributes.parentSectionId,
            }))

        if (model && model.id) {
            let updates = {}
            const allowedFields = [
                "name",
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (model.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            apiCalls.unshift(AppContext.getApiClient().patch('/guided-selling-models/' + model.id, updates))

            const oldSections = this.flatSections(model.attributes.sections)
            // remove sections that has been deleted
            for (let i in oldSections) {
                const section = oldSections[i]
                if (newSections.filter(s => section.id === s.id).length === 0) {
                    apiCalls.push(AppContext.getApiClient().delete('/guided-selling-sections/' + section.id))
                }
            }
        } else {
            apiCalls.unshift(AppContext.getApiClient().put('/guided-selling-models/' + this.state.id, {
                "name": this.state.name,
            }))
        }
        return Promise.all(apiCalls)
    }

    submitModel(event) {
        event.preventDefault()
        this.saveModel().then(responses => {
            let hasError = false
            for (let index in responses) {
                const response = responses[index]
                if (response.error) {
                    hasError = true
                }
            }
            if (!hasError) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/models/listing' }} /> })
            }
        })
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSectionsChange(sections) {
        this.setState({
            sections: sections
        })
    }

    render() {
        const messages = defineMessages({
            "guided_selling.form.edit.name_placeholder": {
                id: 'guided_selling.form.edit.name_placeholder',
                defaultMessage: 'Name of the model',
            },
            "guided_selling.form.edit.save_btn": {
                id: 'guided_selling.form.edit.save_btn',
                defaultMessage: 'Save Model',
            }
        })

        return (
            <form onSubmit={this.submitModel}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="labelTitle">
                                <FormattedMessage
                                    id="guided_selling.form.edit.title_label"
                                    defaultMessage="Name"
                                />
                            </label>
                            <div className="col-10">
                                <input
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleFormChange}
                                    id="modelName"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['guided_selling.form.edit.name_placeholder'])}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="guided_selling.form.edit.name_description"
                                        defaultMessage="Describe the model in a few words"
                                    />
                                </small>
                            </div>
                        </div>
                    </div>
                    <SectionsEditForm
                        sections={this.state.sections}
                        onChange={this.handleSectionsChange}
                        modelId={this.state.id}
                    />
                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.deleteButton}
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/models/listing" className="btn btn-light">
                                    <FormattedMessage
                                        id="guided_selling.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(messages['guided_selling.form.edit.save_btn'])} className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(ModelEditForm)


// WEBPACK FOOTER //
// ./src/guided-selling/form/edit.component.jsx